import fetchWrapper from '../fetchWrapper';
import { CloudProvider } from 'js/project/nds/types/provider';

export function getPrivateEndpointsForServerlessProject(groupId: string, cloudProvider: CloudProvider) {
  return fetchWrapper(`/nds/${groupId}/privateEndpoint/serverless/${cloudProvider}`, {
    method: 'GET',
  }).then((resp) => resp.json());
}
